function Button({ label, type, handleClick }) {
  return (
    <button type={type} className="button" onClick={handleClick}>
      {label}
    </button>
  );
}
export default Button;
